import { ArrowRightOutlined, EditOutlined, LockOutlined } from '@ant-design/icons';
import { Button, Space, TablePaginationConfig, Tooltip } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge, Switch, Table } from 'components';
import {
  StyledTableHeader,
  StyledTableWrapper,
} from 'components/table/table.styled';
import { getUserFullName } from 'features/users';
import { AddAppUserModal } from 'features/users/components/modals/add-app-user-modal';
import { ChangePasswordModal } from 'features/users/components/modals/change-password-modal';
import { EndUserFilterFormValuesPaginated } from 'features/users/components/users-filter-form';
import { useUpdateUserStatus } from 'features/users/use-cases';
import {Dispatch, SetStateAction,useState } from 'react' ;
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { SideBarMenus } from 'routes/constants';
import { User } from 'types';
import { HasPermission } from 'utils/CheckPermissions';

type UsersTableProps = {
  isUsersListLoading: boolean;
  usersList: User[];
  itemsCount: number;
  tableParams: EndUserFilterFormValuesPaginated;
  updateParams: Dispatch<SetStateAction<EndUserFilterFormValuesPaginated>>;
  userEditData: any;
  setUserEditData: any;
  onRefresh :  () => void ;
  isFetching : boolean ;
};
export const EndUsersTable = ({
  usersList,
  isUsersListLoading,
  itemsCount,
  tableParams,
  updateParams,
  userEditData,
  setUserEditData,
  onRefresh ,
  isFetching
}: UsersTableProps) => {
  const { t } = useTranslation();
  //const permissions = usePermissions();
  const navigate = useNavigate();
  const [showUpdateUserModal, setShowUpdateUserModal] = useState(false);
  const [loadingSwitchId, setLoadingSwitchId] = useState('');
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [updateUserId, setUpdateUserId] = useState<string>();
  const { mutate: mutateUpdateUserStatus, isLoading: isLoadingUpdateUserStatus } = useUpdateUserStatus();


  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<User> | SorterResult<User>[],
  ) => {

    updateParams({
      ...tableParams,
      page: pagination.current,
      size: pagination.pageSize,
      order_by: Array.isArray(sorter)
        ? undefined
        : sorter.order === 'ascend'
          ? 'name'
          : '-name',
    });
  };
  const handleCloseModal = () => {
    setShowUpdateUserModal(false);
    setUserEditData(undefined);
  }
  const handleOpenModal = (record: any) => {    
    setShowUpdateUserModal(true);
    setUserEditData(record);
  }

  const showAdminDetail = (record: any) => {
    navigate(`/users/admin/${record.userId}/detail`);
  }

   const handleOpenChangePasswordModal = (record: any) =>{
          setUpdateUserId(record.userId);
          setShowChangePasswordModal(true);              
   }

    const handleChangePCloseModal = () => {
    setUpdateUserId('');
    setShowChangePasswordModal(false);
  }

  


  return (
    <>
      {showUpdateUserModal ? (<div className={`cstmrightmdl ${showUpdateUserModal && "show"}`}>
        <AddAppUserModal onClose={handleCloseModal} userEditData={userEditData} />
      </div>) : ''}
       
        {showChangePasswordModal ? (<div className={`cstmrightmdl ${showChangePasswordModal && "show"}`}>
        <ChangePasswordModal onClose={handleChangePCloseModal} updateUserId={updateUserId} />
      </div>) : ''}
      <StyledTableWrapper>
        <StyledTableHeader>
          <RecordCountBadge
            text={t('adminUsers.foundUsers')}
            count={itemsCount}
          />     
          <Button
          type="link"                // 👈 makes it look like blue text
          onClick={onRefresh}
          loading={isUsersListLoading}
          style={{ padding: 0, marginBottom: 16 }}
        >
          Refresh Data
        </Button>
        </StyledTableHeader>  

       


        <Table<User>
          loading={isUsersListLoading || isFetching}
          dataSource={usersList}
          rowKey='id'
          onChange={handleTableChange}
          pagination={{
            current: tableParams.page,
            defaultPageSize: tableParams.size,
            total: itemsCount,
          }}
          scroll={{ x: 940 }}
        >
           <Column
            key={'detail'}
            title={''}
            dataIndex={'detail'}
            render={() => <ArrowRightOutlined />}

            onCell={(record) => {
              return {
                onClick: () => {
                  const selection = window?.getSelection()?.toString();
                  if (!selection?.length) {
                    showAdminDetail(record)
                  }
                },
              };
            }}
          />
          <Column<User>
            title={t('adminUsers.table.customerName')}
            dataIndex={'customerName'}
            render={(_, record) => getUserFullName(record)}
            sorter={true}
            sortDirections={['ascend', 'descend', 'ascend']}
            defaultSortOrder={'ascend'}
          />
          <Column<User>
            title={t('adminUsers.table.email')}
            dataIndex={'user'}
            render={(_, record) => record.email}
          />
           <Column<User>
            title={'Username'}
            dataIndex={'user'}
            render={(_, record) => record.userName}
          />
          <Column<User>
            title={t('adminUsers.table.phoneNumber')}
            dataIndex={'user'}
            render={(_, record) => record.phoneNumber}
          />

          <Column<User>
            title={'Role'}
            dataIndex={'user'}
            render={(_, record) =>
              record.roleType
            }
          />

           {HasPermission(SideBarMenus.ADMIN, 'edit') ? (
          <Column<User>
            title={"Action"}
            dataIndex={'user'}
            render={(_, record) => (
              <Space>
                <Tooltip title="Edit">
                  <Button shape="circle" icon={<EditOutlined />} onClick={() => handleOpenModal(record)} />
                </Tooltip>
                <Tooltip title="is active">
                   <Switch
                    defaultChecked={record.isActive}
                    checked={record.isActive}
                    loading={loadingSwitchId == record.userId && isLoadingUpdateUserStatus}
                    onChange={(isChecked) => {
                      setLoadingSwitchId(record.userId);
                      mutateUpdateUserStatus({
                        Id: record.userId,
                        is_active: isChecked,
                        flag: "status_updated"
                      })
                    }}
                    onClick={(checked, event) => {
                      event.stopPropagation();
                      event.preventDefault();
                    }}
                  /> 
                </Tooltip>
                <Tooltip title="Change Password">
                   <Button icon={<LockOutlined />}  onClick={() => handleOpenChangePasswordModal(record)}></Button>  
              </Tooltip>
              </Space>
            )}
          />):null  }
        </Table>
      </StyledTableWrapper>
    </>
  );
};